import { useCallback, useState } from 'react';

export const useLoading = (initialValue = false) => {
  const [isLoading, setIsLoading] = useState(initialValue);
  const showLoading = useCallback(() => {
    setIsLoading(true);
  }, []);

  const hideLoading = useCallback(() => {
    setIsLoading(false);
  }, []);

  const toggleLoading = useCallback(() => {
    setIsLoading((old) => !old);
  }, []);

  return {
    isLoading,
    showLoading,
    hideLoading,
    toggleLoading,
  };
};

export default useLoading;
